"use client";

import type {ComponentType} from "react";
import RedialingRuleToolDetails from "./RedialingRuleToolDetails";
import SequenceToolDetails from "./SequenceToolDetails";
import WorkflowToolDetails from "./WorkflowToolDetails";
import UseCaseToolDetails from "./UseCaseToolDetails";
import ScriptToolDetails from "@/components/scripts/presentation/ScriptDetails";
import ToolPresentationDetails, {type ToolDetailsProps} from "./ToolPresentationDetails";
import {ApprovalReferenceProvider} from "./ApprovalReferenceValue";

const toolRenderers: ReadonlyMap<string, ComponentType<ToolDetailsProps>> = new Map([
   ["omega_publishcustomerworkflow", WorkflowToolDetails],
   ["phone_scripts_create", ScriptToolDetails],
   ["use_cases_create", UseCaseToolDetails],
   ["redialing_rules_create", RedialingRuleToolDetails],
   ["redialing_rules_update", RedialingRuleToolDetails],
   ["sequences_create", SequenceToolDetails],
   ["sequences_update", SequenceToolDetails],
]);

/** Routes tool content independently of approval state and decision controls. */
export default function ToolDetails(props: ToolDetailsProps) {
   return <ApprovalReferenceProvider presentation={props.presentation} parameters={props.parameters}><ToolDetailsContent {...props} /></ApprovalReferenceProvider>;
}

/** Approval cards already own the reference context for their complete review. */
export function ToolDetailsContent(props: ToolDetailsProps) {
   const Renderer = toolRenderers.get(props.presentation.toolName) ?? ToolPresentationDetails;
   return <Renderer {...props} />;
}
